import { useEffect, useRef, useState } from "react";
import {
  Container,
  Navbar,
  Nav,
  Button,
  Dropdown,
  Card,
  Image,
} from "react-bootstrap";
import { BoxArrowRight, ThreeDotsVertical } from "react-bootstrap-icons";
import dashboardicon from "../../assets/svg/Dashboard_Black.svg";
import dashboardWhiteicon from "../../assets/svg/Dashboard_White.svg";
import { useSelector, useDispatch } from "react-redux";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  adminReset,
  adminLogoutSuccess,
  adminLogoutFailure,
} from "../../store/reducerSlice/admin";
import {
  adminLogin,
  getProfile,
  adminLogout,
} from "../../store/actions/adminAction";
import {
  setManageClientPage,
  resetManageClientPage,
} from "../../store/reducerSlice/clients";
import {
  setManageConditionPage,
  resetManageConditionPage,
} from "../../store/reducerSlice/conditions";
import Logo from "../common/Logo/Logo";
import styles from "./Header.module.css";
import ProfileImage from "../../assets/images/photo.svg";
import profileIcon from "../../assets/images/profile-icon.png";

const AdminHeader = () => {
  const navigate = useNavigate();
  const [isShow, setIsShow] = useState(false);
  const admin = useSelector((state) => state.admin);
  const { adminDetail } = admin;
  const dispatch = useDispatch();
  const urllocation = useLocation();
  const logoutRef = useRef();
  const [isDashboardPage, setIsDashbaordPage] = useState(false);
  console.log("path", urllocation.pathname);
  useEffect(() => {
    console.log("adminDetail-01", adminDetail);
    // if (adminDetail?.isWardSystemAccessible) {
    //   console.log("Navigating to /");
    //   setIsDashbaordPage(true);
    //   navigate("/");
    // } else {
    //   console.log("Navigating to /manage-client");
    //   navigate("/manage-client");
    // }
  }, [adminDetail]);
  useEffect(() => {
    console.log("path", urllocation.pathname);
    if (urllocation.pathname === "/") {
      console.log("path matched", urllocation.pathname);
      console.log("adminDetail-01", adminDetail);

      setIsDashbaordPage(true);
    } else {
      console.log("path not matched", urllocation.pathname);
      setIsDashbaordPage(false);
    }
  }, [urllocation.pathname]);

  useEffect(() => {
    if (admin.invalidJwtToken) {
      // localStorage.removeItem('admin');
      // dispatch(adminReset())
      logoutRef.current.click();
    }
  }, [admin.invalidJwtToken]);
  useEffect(() => {
    if (!adminDetail?.clientId) {
      dispatch(getProfile());
    }
    console.log("admin", admin);
  }, []);
  // useEffect(()=>{

  // },[])
  const logOutClient = () => {
    dispatch(adminLogout())
      .then(() => {
        dispatch(adminLogoutSuccess());
        localStorage.removeItem("authorization");
        dispatch(adminReset());
        // Additional actions after successful logout, such as redirecting to a login page
        navigate("/login");
      })
      .catch((error) => {
        dispatch(adminLogoutFailure(error));
        // Handle logout failure
        console.log(error);
      });
  };
  const resetPage = () => {
    dispatch(resetManageClientPage());
    dispatch(resetManageConditionPage());
  };

  const setConditionPage = () => {
    dispatch(resetManageClientPage());
    dispatch(setManageConditionPage());
  };

  const setClientPage = () => {
    dispatch(resetManageConditionPage());
    dispatch(setManageClientPage());
  };
  const isTrue = useRef(true);
  /* ===============================
     NEW LOGIC (ONLY ADDITION)
  =============================== */
  const isOnlyIMCStroke =
    Array.isArray(adminDetail?.wardTypes) &&
    adminDetail.wardTypes.length === 1 &&
    adminDetail.wardTypes[0] === "IMC-STROKE";

  /* =============================== */

  const headerLinks = () => {
    return (
      <>
        {adminDetail?.isWardSystemAccessible && (
          <>
            {isDashboardPage ? (
              <NavLink
                to="/"
                className="btn  btn-primary "
                onClick={setConditionPage}
              >
                <img
                  height="18"
                  width="18"
                  className="svgEffect"
                  src={dashboardicon}
                  alt="img"
                />
                <img
                  height="18"
                  width="18"
                  className="svgEffect1"
                  src={dashboardWhiteicon}
                  alt="img"
                />
              </NavLink>
            ) : (
              <NavLink
                to="/"
                className={({ isActive }) => "btn  " + "btn-outline-primary"}
                onClick={setConditionPage}
              >
                <img
                  height="18"
                  width="18"
                  className="svgEffect"
                  src={dashboardicon}
                  alt="img"
                />
                <img
                  height="18"
                  width="18"
                  className="svgEffect1"
                  src={dashboardWhiteicon}
                  alt="img"
                />
              </NavLink>
            )}
          </>
        )}
        {/* {isManageClientPage ? (
          <NavLink
            to="/manage-ward"
            className="btn btn-primary"
            onClick={setClientPage}
          >
            Manage Wards
          </NavLink>
        ) : (
          <NavLink
            to="/manage-ward"
            className={({ isActive }) =>
              "btn " + (isActive ? "btn-primary" : "btn-outline-primary")
            }
            onClick={setClientPage}
          >
            Manage Wards
          </NavLink>
        )} */}
        {adminDetail?.isWardSystemAccessible && (
          <>
            <NavLink
              to="/manage-ward"
              className={({ isActive }) =>
                "btn " + (isActive ? "btn-primary" : "btn-outline-primary")
              }
              onClick={setClientPage}
            >
              Manage Wards
            </NavLink>
          </>
        )}
        {!isOnlyIMCStroke && (
          <NavLink
            to="/manage-client"
            className={({ isActive }) =>
              "btn " + (isActive ? "btn-primary" : "btn-outline-primary")
            }
            onClick={setClientPage}
          >
            Manage Admin
          </NavLink>
        )}

        {adminDetail?.isUCRTEnabled && (
          <>
            <NavLink
              to="/ucrt-module"
              className={({ isActive }) =>
                "btn " + (isActive ? "btn-primary" : "btn-outline-primary")
              }
              onClick={resetPage}
            >
              UCRT
            </NavLink>
            {!adminDetail?.isAdmin && !adminDetail?.isWardSystemAccessible && (
              <NavLink
                to="/ucrt-audit-trail"
                className={({ isActive }) =>
                  "btn " + (isActive ? "btn-primary" : "btn-outline-primary")
                }
                onClick={resetPage}
              >
                UCRT Audit Trails
              </NavLink>
            )}
          </>
        )}
        {adminDetail?.isIMCEnabled && (
          <>
            <NavLink
              to="/imc"
              className={({ isActive }) =>
                "btn " + (isActive ? "btn-primary" : "btn-outline-primary")
              }
              onClick={resetPage}
            >
              IMC /Stroke
            </NavLink>
            {!adminDetail?.isAdmin && adminDetail?.isIMCEnabled && (
              <NavLink
                to="/imc-audit-trail"
                className={({ isActive }) =>
                  "btn " + (isActive ? "btn-primary" : "btn-outline-primary")
                }
                onClick={resetPage}
              >
                IMC/Stroke Audit Trails
              </NavLink>
            )}
          </>
        )}
        {adminDetail?.isWardSystemAccessible && !adminDetail?.isAdmin && (
          <>
            <NavLink
              to="/report"
              className={({ isActive }) =>
                "btn " + (isActive ? "btn-primary" : "btn-outline-primary")
              }
              onClick={resetPage}
            >
              Reports
            </NavLink>
            {!adminDetail?.isUCRTEnabled && (
              <NavLink
                className={({ isActive }) =>
                  "btn " + (isActive ? "btn-primary" : "btn-outline-primary")
                }
                to="/audit-trail"
                onClick={resetPage}
              >
                Audit Trails
              </NavLink>
            )}
          </>
        )}
        {adminDetail?.isAdmin && (
          <>
            <NavLink
              to="/report"
              className={({ isActive }) =>
                "btn " + (isActive ? "btn-primary" : "btn-outline-primary")
              }
              onClick={resetPage}
            >
              Reports
            </NavLink>
          </>
        )}

        {!adminDetail?.isAdmin ||
          (adminDetail?.isWardSystemAccessible &&
            !adminDetail?.isUCRTEnabled && (
              <>
                <NavLink
                  to="/audit-trail"
                  className={({ isActive }) =>
                    "btn " + (isActive ? "btn-primary" : "btn-outline-primary")
                  }
                  onClick={resetPage}
                >
                  Audit Trails
                </NavLink>
              </>
            ))}

        {/* {adminDetail?.isAdmin && (
          <NavLink
            to="/geography"
            className={({ isActive }) =>
              "btn " + (isActive ? "btn-primary " : "btn-outline-primary")
            }
            onClick={resetPage}
          >
            Geography
          </NavLink>
        )} */}
        {adminDetail?.isAdmin && (
          <>
            <Dropdown align="end">
              <Dropdown.Toggle style={{ background: "none", color: "#2A2338" }}>
                <ThreeDotsVertical style={{ color: "#2A2338" }} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {adminDetail?.isAdmin && (
                  <Dropdown.Item onClick={() => navigate("/geography")}>
                    <NavLink
                      style={{
                        textDecoration: "none",
                        color: "#2A2338",
                        fontWeight: "400",
                      }}
                      to="/geography"
                      onClick={resetPage}
                    >
                      Geography
                    </NavLink>
                  </Dropdown.Item>
                )}

                <Dropdown.Item onClick={() => navigate("/audit-trail")}>
                  <NavLink
                    style={{
                      textDecoration: "none",
                      color: "#2A2338",
                      fontWeight: "400",
                    }}
                    to="/audit-trail"
                    onClick={resetPage}
                  >
                    Audit Trails
                  </NavLink>
                </Dropdown.Item>
                <Dropdown.Item onClick={() => navigate("/ucrt-audit-trail")}>
                  <NavLink
                    style={{
                      textDecoration: "none",
                      color: "#2A2338",
                      fontWeight: "400",
                    }}
                    to="/ucrt-audit-trail"
                    onClick={resetPage}
                  >
                    UCRT Audit Trails
                  </NavLink>
                </Dropdown.Item>
                <Dropdown.Item onClick={() => navigate("/imc-audit-trail")}>
                  <NavLink
                    style={{
                      textDecoration: "none",
                      color: "#2A2338",
                      fontWeight: "400",
                    }}
                    to="/imc-audit-trail"
                    onClick={resetPage}
                  >
                    IMC/Stroke Audit Trails
                  </NavLink>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </>
        )}
        {adminDetail?.isWardSystemAccessible &&
          adminDetail?.isUCRTEnabled &&
          !adminDetail?.isAdmin && (
            <>
              <Dropdown align="end">
                <Dropdown.Toggle
                  style={{ background: "none", color: "#2A2338" }}
                >
                  <ThreeDotsVertical style={{ color: "#2A2338" }} />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => navigate("/audit-trail")}>
                    <NavLink
                      style={{
                        textDecoration: "none",
                        color: "#2A2338",
                        fontWeight: "400",
                      }}
                      to="/audit-trail"
                      onClick={resetPage}
                    >
                      Audit Trails
                    </NavLink>
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => navigate("/ucrt-audit-trail")}>
                    <NavLink
                      style={{
                        textDecoration: "none",
                        color: "#2A2338",
                        fontWeight: "400",
                      }}
                      to="/ucrt-audit-trail"
                      onClick={resetPage}
                    >
                      UCRT Audit Trails
                    </NavLink>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </>
          )}
        <Button
          style={{ border: "0px" }}
          className="d-block d-lg-none"
          variant="outline-info"
          href="/login"
          onClick={logOutClient}
        >
          Logout <BoxArrowRight />
        </Button>
      </>
    );
  };

  return (
    <Navbar
      className={`${styles.header} ${
        admin?.isAdminLoggedIn && styles.loggedIn
      } `}
      style={{ zIndex: 9 }}
      expand="lg"
    >
      <Container className="client-head bg-white">
        <Navbar.Brand>
          <Link to="/">
            <Logo />
          </Link>
        </Navbar.Brand>
        {admin?.isAdminLoggedIn && (
          <>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav
                className={`me-auto justify-content-center text-center ${styles.adminMenu}`}
              >
                {headerLinks()}
              </Nav>
              <Navbar.Collapse className="justify-content-end d-none profileGroup">
                <Dropdown className="-me-6" style={{ border: "0px" }}>
                  <Dropdown.Toggle variant="none" id="dropdown-basic">
                    {adminDetail?.logo ? (
                      <Image
                        className="profileimgLogo"
                        src={adminDetail?.logo}
                        alt=""
                        style={{
                          height: "44px",
                        }}
                      />
                    ) : (
                      <Image
                        className="w-36"
                        src={ProfileImage}
                        height="36"
                        alt=""
                      />
                    )}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item href="/update-profile">
                      <img src={profileIcon} alt="img" /> Profile
                    </Dropdown.Item>
                    <Dropdown.Item onClick={logOutClient}>
                      <BoxArrowRight style={{ color: "#855DD9" }} /> Logout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <div className="profile w-36">
                  Hi, {adminDetail?.contactName}
                  <br />
                  <span>{adminDetail?.clientName}</span>
                  <br />
                  <span>Client</span>
                </div>
              </Navbar.Collapse>
            </Navbar.Collapse>
          </>
        )}
      </Container>
    </Navbar>
  );
};

export default AdminHeader;
